module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (canShow) { ;
__p += '\n    <div class="suggestions__empty">\n        ';
 if (saved.length === 0) { ;
__p += '\n            <img src="' +
__e( $.staticURL('no-matches-illo.svg') ) +
'" />\n            <p class="suggestions__empty-header">No matches currently&mdash;come back later!</p>\n            ';
 if (unansweredCount > 0 ) { ;
__p += '\n                <p class="suggestions__empty-subheader">Answer more questions to improve your suggestions:</p>\n                <a href="/u/questions/" class="btn btn-secondary js-answer-btn">Answer questions</a>\n            ';
 } ;
__p += '\n        ';
 } else { ;
__p += '\n            <img src="' +
__e( $.staticURL('illo-briefcase.svg') ) +
'" />\n            <p class="suggestions__empty-header">\n                You saved ' +
__e( saved.length ) +
' job';
 if (saved.length > 1) { ;
__p += 's';
 } ;
__p += '.\n                Do you want to apply to ';
 if (saved.length === 1) { ;
__p += 'it';
 } else { ;
__p += 'them';
 } ;
__p += ' now?\n            </p>\n            <a href="/app/start/?sn=0&p=' +
__e( saved.join(',') ) +
'&utm_medium=matches-saved" class="btn btn-primary btn-large">\n                Apply (' +
__e( saved.length ) +
')\n            </a>\n        ';
 } ;
__p += '\n    </div>\n';
 } else { ;
__p += '\n    <div class="suggestions__unlock">\n        <img src="' +
__e( $.staticURL('unlock-matches-illo.svg') ) +
'" />\n        <p class="suggestions__unlock-header">Unlock Matches</p>\n        <p class="suggestions__unlock-subheader">\n            Matches we find for you are <strong>80%</strong> more likely\n            to result in an interview\n        </p>\n        <a href="/u/questions/" class="btn btn-primary btn-large js-unlock-btn">Unlock Matches</a>\n        <p class="suggestions__unlock-footer">\n            It\'s easy&mdash;just answer 20 questions\n            ';
 if (answerCount > 0) { ;
__p += '\n                <br />(You\'ve already answered ' +
__e( answerCount ) +
')\n            ';
 } ;
__p += '\n        </p>\n    </div>\n';
 } ;
__p += '\n';

}
return __p
}